<script setup>
import CampaignCard from 'dashboard/components-next/Campaigns/CampaignCard/CampaignCard.vue';

const props = defineProps({
  campaigns: {
    type: Array,
    required: true,
  },
  isLiveChatType: {
    type: Boolean,
    default: false,
  },
  reportRouteResolver: {
    type: Function,
    default: null,
  },
  flowRouteResolver: {
    type: Function,
    default: null,
  },
});

const emit = defineEmits(['edit', 'delete', 'duplicate']);

const handleEdit = campaign => emit('edit', campaign);
const handleDelete = campaign => emit('delete', campaign);
const handleDuplicate = campaign => emit('duplicate', campaign);

const resolveReport = campaign => {
  if (!props.reportRouteResolver) return null;
  return props.reportRouteResolver(campaign);
};

const resolveFlow = campaign => {
  if (!props.flowRouteResolver) return null;
  return props.flowRouteResolver(campaign);
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <CampaignCard
      v-for="campaign in campaigns"
      :key="campaign.id"
      :title="campaign.title"
      :message="campaign.message"
      :is-enabled="campaign.enabled"
      :status="campaign.campaign_status"
      :sender="campaign.sender"
      :inbox="campaign.inbox"
      :scheduled-at="campaign.scheduled_at"
      :recurrence-type="campaign.recurrence_type"
      :next-run-at="campaign.next_run_at"
      :run-count="campaign.run_count"
      :message-counts="campaign.message_counts"
      :is-live-chat-type="isLiveChatType"
      :report-route="resolveReport(campaign)"
      :flow-route="resolveFlow(campaign)"
      @edit="handleEdit(campaign)"
      @delete="handleDelete(campaign)"
      @duplicate="handleDuplicate(campaign)"
    />
  </div>
</template>
